export default __webpack_public_path__ + "static/media/Dima.3d16ce1f.jpg";